import { useCallback, useEffect, useState } from 'react';;
import { Link } from 'react-router';
import { MapPin, BriefcaseBusiness, Clock, ArrowUpRight } from "@repo/ui/components/icon";
import { ScrollArea, ScrollBar } from '@repo/ui/components/scroll-area';
import { IProvincesResponse, JobApiResponse } from '~/types/types';
import { buildRegionItems, formatDeadline } from '~/utils/format';
import queryString from 'query-string';
import { clientCallAPI } from '~/services/clientCallAPI';


type NormalizedJob = {
  id: string;
  title: string;
  slug: string;
  location: string;

  type: string;
  closingDate: string;

  isFeatured?: boolean;
};
const DEFAULT_PAGE_SIZE = 8;
export default function RecruitmentOpenings({ data }: { data: IProvincesResponse }) {

  const locationFilters = buildRegionItems(data);
  const [jobs, setJobs] = useState<NormalizedJob[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<string>("all");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [pageMeta, setPageMeta] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  });
  const fetchJobs = useCallback(
    async (provinceId: string, page: number, append = false) => {
      setLoading(true);
      setError(null);

      const param = {
        PageNumber: page,
        PageSize: DEFAULT_PAGE_SIZE,
        provinceId: provinceId === 'all' ? null : provinceId
      };
      const stringified = queryString.stringify(param, {
        skipEmptyString: true,
        skipNull: true,
      });
      try {
        const response: JobApiResponse = await clientCallAPI<JobApiResponse>(
          "/api/job?" + stringified
        );

             const normalized = (response.data || []).map((item, index) => {
               const isFeatured = !append && page === 1 && index === 0;

               return {
                 id: item.id,
                 slug: item.slug,
                 title: item.jobTitle,
                 location: item.provinceName,
                 type:  item.jobTypeName,
                 closingDate: formatDeadline(item.applicationDeadline),
                //  updatedLabel,
                 isFeatured,
               } satisfies NormalizedJob;
             });
                setJobs((prev) =>
                  append ? [...prev, ...normalized] : normalized
                );
        setPageMeta((prev) => ({
          currentPage: response.currentPage ?? page,
          totalPages: response.totalPages ?? prev.totalPages,
          totalCount:
            response.totalCount ?? (append ? prev.totalCount : response.data.length),
        }));

      } catch (err) {
        setError(
          "Không thể tải danh sách tuyển dụng. Vui lòng thử lại sau."
        );
        if (!append) {
          setJobs([]);
          setPageMeta({ currentPage: 1, totalPages: 1, totalCount: 0 });
        }
      } finally {
        // setLoading(false);
      }
    },
    []
  );
  useEffect(() => {
    fetchJobs(selectedLocation, 1, false);
  }, [selectedLocation]);
 const handleLoadMore = () => {
   if (loading) return;
   const nextPage = pageMeta.currentPage + 1;
   if (nextPage > pageMeta.totalPages) return;
   fetchJobs(selectedLocation, nextPage, true);
 };
  const hasMore = jobs.length < pageMeta.totalCount;
  return (

      <div className="flex flex-col items-start gap-6 md:flex-row">
        <div className="bg-gray-200 rounded-2xl">
          <ScrollArea className="w-[320px]">
            <div className="flex flex-row gap-3 p-5 w-max md:flex-col">
              {locationFilters.map((filter) => {
                const isActive = selectedLocation === filter.id;

                return (
                  <button
                    key={filter.id}
                    type="button"
                    onClick={() => setSelectedLocation(filter.id)}
                    className={
                      "flex w-full items-center justify-between rounded-md px-4 py-3 text-left text-base font-medium transition-colors min-w-[200px] md:min-w-[280px] " +
                      (isActive
                        ? "bg-primary text-white shadow-lg"
                        : "hover:text-primary hover:bg-primary-100/60")
                    }
                  >
                    <span>{filter.label}</span>
                    <span className="inline-flex h-6 min-w-[1.75rem] items-center justify-center rounded-full px-2 text-base">
                      {filter.count}
                    </span>
                  </button>
                );
              })}
            </div>
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        </div>

        <div className="flex-1">
          <div className="space-y-4">
            {jobs.map((job) => {
              return (
                <Link
                  key={job.id}
                  to={`/tuyen-dung/${job.slug}`}
                  className={
                    "block  group transition-all duration-200 hover:translate-y-[-2px] hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 hover:text-white hover:bg-primary bg-primary-50 rounded-xl"
                  }
                >
                  <div className="flex p-6">
                    <div className="flex flex-col flex-1 gap-4 md:flex-row md:items-center ">
                      <div>
                        <h3 className={" text-xl font-bold"}>{job.title}</h3>

                        <div
                          className={
                            "mt-3 flex flex-wrap items-center gap-4 text-sm"
                          }
                        >
                          <span className="inline-flex items-center gap-2">
                            <MapPin size={16} className="text-[#65C9D3]" />
                            {job.location}
                          </span>
                          <span className="inline-flex items-center gap-2">
                            <BriefcaseBusiness
                              size={16}
                              className="text-[#65C9D3]"
                            />
                            {job.type}
                          </span>
                          <span className="inline-flex items-center gap-2">
                            <Clock size={16} className="text-[#65C9D3]" />
                            {job.closingDate}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center self-start gap-2 ">
                      <span
                        className={
                          "text-sm font-semibold text-primary group-hover:text-white"
                        }
                      >
                        <ArrowUpRight />
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
          {jobs.length === 0 && !loading && !error ? (
            <div className="px-6 py-10 mt-6 text-sm text-center border border-dashed rounded-xl border-primary/40 bg-primary/5 text-primary">
              Hiện chưa có vị trí tuyển dụng phù hợp ở khu vực này.
            </div>
          ) : null}
          <div className="flex justify-center mt-8">
            {hasMore ? (
              <button
                type="button"
                onClick={handleLoadMore}
                disabled={loading}
                className="px-6 py-3 text-sm font-semibold text-white transition rounded-full shadow-lg bg-primary hover:bg-primary-600 disabled:cursor-not-allowed disabled:bg-primary/60"
              >
                {loading ? "Đang tải..." : "Tải thêm"}
              </button>
            ) : null}
          </div>
        </div>
      </div>

  );
}

